import { PAGE_COUNTRY_MAP } from '@/src/constants/domain'

/**
 * Maps hostname to GTM page_country code
 * @param hostname - The hostname from window.location.hostname
 * @returns GTM country code ('global', 'eg', 'ae')
 */
export const getGtmPageCountry = (hostname: string): string => {
    if (!hostname) return 'global'

    const origin = `https://${hostname.toLowerCase()}`
    const pageCountry = PAGE_COUNTRY_MAP[origin as keyof typeof PAGE_COUNTRY_MAP]

    return pageCountry || 'global'
}

